import {HttpClient} from "../../service/httpClient/HttpClient";

export class TourismCategoryService {
    constructor() {
        this.httpClient = new HttpClient()
    }


    getCategoryListByLanguage(languageCode = "fa-rIR") {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `location-categories/trees`,
                {
                    "language-code": languageCode
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewCategory(title, slug, parentId) {
        const persianCode = `fa-rIR`

        let data

        if (parentId >= 0) {
            data = {
                slug,
                metaData: {
                    title
                },
                parent: {
                    id: parentId
                },
                isRoot: false
            }
        } else {
            data = {
                slug,
                metaData: {
                    title
                },
                isRoot: true
            }
        }

        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `languages/${persianCode}/location-categories`,
                data
            ).then(resolve).catch(reject)
        })
    }

    getCategoryDetail(id, language) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `location-categories/${id}`,
                {
                    "language-code": language
                }
            ).then(resolve).catch(reject)
        })
    }

    updateCategoryInfo(id, language, name, slug, parentId) {
        let data

        if (parentId >= 0) {
            data = {
                slug,
                metaData: {
                    title: name
                },
                parent: {
                    id: parentId
                },
                isRoot: false
            }
        } else {
            data = {
                slug,
                metaData: {
                    title: name
                },
                isRoot: true
            }
        }

        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `languages/${language}/location-categories/${id}`,
                data
            ).then(resolve).catch(reject)
        })
    }
}